// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { PortalBaseEntity } from '../portal-base-entity';
import { BankAccount } from './bank-account';
import { BankAccountFeed } from './bank-account-feed';
import { Practice } from './practice';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Job extends PortalBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  jobId!: number;
  counterPartyCounterPartyId?: number;
  createdAt!: Date;
  createdBy!: string;
  deleted!: boolean;
  description?: string;
  discriminator!: string;
  endDate?: Date;
  isPublic!: boolean;
  jobCode?: string;
  jobCulture?: string;
  jobGuid!: string;
  jobParentId?: number;
  jobStatus!: number;
  jobTypeId!: number;
  jobname!: string;
  metadata?: string;
  practiceId?: number;
  startDate?: Date;
  ts!: string;
  updatedAt!: Date;
  updatedBy!: string;
  version!: any;
  bankAccountFeeds!: BankAccountFeed[];
  bankAccounts!: BankAccount[];
  inverseJobParent!: Job[];
  jobParent!: Job;
  practice!: Practice;
}

